export default __webpack_public_path__ + "28721e2b2962db926c6d02e6468e9741.jpg";